/* global axios */
import ApiClient from './ApiClient';

class WidgetLoadReportsAPI extends ApiClient {
  constructor() {
    super('widget_load_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getMetrics(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new WidgetLoadReportsAPI();
